import { morphism } from 'morphism'

import tourOperatorSchema from '../../schemas/tourOperator'

import tourOperatorModel from '../../models/TourOperator'

import staticData from '../../config/staticData'

import callAPI from '../../utils/requests/callAPI'
import setAuthorizationHeader from '../../utils/requests/setAuthorizationHeader'

import { V1_REQUEST_TOUR_OPERATORS } from '../../actions/tourOperators/v1requestTourOperators'
import { v1receiveTourOperators } from '../../actions/tourOperators'
import { v1setUserHasCustomTourOperatorOverwrite } from '../../actions/users'
import v1throwError from '../../actions/errors/v1throwError'

export default store => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_TOUR_OPERATORS) {
    return
  }

  const dispatch = store.dispatch

  try {
    const headers = new Headers(staticData.endpoints.allotments.headers)
    await setAuthorizationHeader(headers)

    const data = await callAPI(
      `${staticData.endpoints.allotments.url}touroperators`,
      {
        headers,
      }
    )

    if (data.error) throw data.error

    const tourOperators = data.length ? data : []

    const formattedTourOperators = tourOperators.map(tourOperator => {
      return morphism(tourOperatorSchema, tourOperator, tourOperatorModel)
    })

    dispatch(v1receiveTourOperators(formattedTourOperators))
    dispatch(
      v1setUserHasCustomTourOperatorOverwrite(
        Boolean(formattedTourOperators.length)
      )
    )
  } catch (error) {
    // Suppress the error thrown by being unauthorized on the first render
    // when developing. There will still be an error in the console to show
    // the message catch.
    if (process.env.NODE_ENV === 'development') {
      console.error(error)
      return
    }
    dispatch(v1throwError(error))
  }
}
